import { Plus } from "lucide-react";

export default function ButtonNovo({ label = "Novo Cliente", onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-[#f95000] hover:bg-[#ff6a1a] text-white font-medium rounded-md 
                 transition-all duration-200 hover:scale-105 shadow-md"
    >
      <Plus size={18} />
      {label}
    </button>
  );
}
